"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantComparisonValueInput = void 0;
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../../gen-src/Localize");
var configurationStyles_1 = require("../configurationStyles");
var shakeInputIfInvalid_1 = require("../../../shakeIfInvalid/shakeInputIfInvalid");
var formatting_1 = require("../../../formatting/formatting");
var ConstantComparisonValueInput = function (props) {
    if (props.selectedComparison !== null && !(0, metrics_engine_1.isStaticComparison)(props.selectedComparison)) {
        return null;
    }
    var initialSelectedValueString = getInitialSelectedValueString(props.selectedComparison, props.formatString);
    var _a = React.useState(initialSelectedValueString), inputValue = _a[0], setInputValue = _a[1];
    var clearValue = function () {
        setInputValue('');
        props.onSelectedComparisonChange(null);
    };
    var _b = React.useState(false), hasBeenEdited = _b[0], setHasBeenEdited = _b[1];
    var updateStateValue = function (e) {
        setHasBeenEdited(true);
        var input = e.target.value;
        var value = parseInput(input, props.formatString);
        if ((0, metrics_engine_1.isValidConstantComparison)(value) || input === '') {
            setInputValue(input);
            if (value === null) {
                props.onSelectedComparisonChange(null);
            }
            else {
                props.onSelectedComparisonChange((0, metrics_engine_1.makeStaticComparisonSpec)('', value));
            }
        }
    };
    var inputRef = React.createRef();
    // We only want the input to focus when it is initially rendered and when
    // the selected comparison is null. The empty array as the second useEffect
    // argument accomplishes the "only on initial render".
    React.useEffect(function () {
        var _a;
        if (props.selectedComparison === null) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, []);
    var onBlur = function () {
        setHasBeenEdited(true);
    };
    var invalid = hasBeenEdited && !(0, metrics_engine_1.isValidConstantComparison)(parseInput(inputValue, props.formatString));
    // On validation error, the widget shakes to grab the user's attention if it
    // doesn't have a valid value.  For this particular input, we only want to do
    // this if the value has been edited, since we don't want to an error state on
    // initial render.
    React.useEffect((0, shakeInputIfInvalid_1.shakeInputIfInvalid)(invalid, inputRef), [props.validationCounter]);
    return (React.createElement(widgets_1.TextFieldWidget, { type: "number", max: Number.MAX_SAFE_INTEGER, min: Number.MIN_SAFE_INTEGER, className: configurationStyles_1.comparisonInput, label: Localize_1.Messages.ConstantComparisonValue(), testId: "metric-constant-comparison", onChange: updateStateValue, onClear: clearValue, onBlur: onBlur, value: inputValue, ref: inputRef, valid: invalid ? false : undefined, message: invalid ? Localize_1.Messages.ConstantComparisonInputErrorMessage() : React.createElement("br", null), disabled: props.disabled }));
};
exports.ConstantComparisonValueInput = ConstantComparisonValueInput;
function getInitialSelectedValueString(comparison, formatString) {
    if ((comparison === null || comparison === void 0 ? void 0 : comparison.value) === undefined) {
        return '';
    }
    if ((0, metrics_engine_1.isPercentageFormat)(formatString)) {
        return (0, formatting_1.formatAuthoredPercentOutOf100)(comparison.value);
    }
    return comparison.value.toString();
}
function parseInput(input, formatString) {
    var parsedInput = parseFloat(input);
    var value = isNaN(parsedInput) ? null : parsedInput;
    if (value !== null && (0, metrics_engine_1.isPercentageFormat)(formatString)) {
        value /= 100;
    }
    return value;
}
//# sourceMappingURL=ConstantComparisonValueInput.js.map